import { Actions } from '../actions/settings';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { ILinksSettings } from '../interfaces/settings';

export type State = DeepReadonly<{
  isFetching: boolean;
  links: ILinksSettings | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  links: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_LINKS_SETTINGS_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case 'FETCH_LINKS_SETTINGS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        links: action.payload,
        error: null
      };
    case 'FETCH_LINKS_SETTINGS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
